import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "notification-new-to-pay",
  "use": "notification-new-to-pay-usage",
  "viewBox": "0 0 19 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 18\" id=\"notification-new-to-pay\">\n  <path fill-rule=\"evenodd\" d=\"M1574,934h5v1h-5v-1Zm4,1h1v6h-1v-6Zm0,4v2m-9-5h8v1h-8v-1Zm7,1h1v5h-1v-5Zm-7,0h1v5h-1v-5Zm0,4h7v1h-7v-1Zm2-3h1v2h-1v-2Zm3,0h1v2h-1v-2Zm-3,1v-1h3m0,1v1h-2m2.17-10.333a5.665,5.665,0,1,0-8.68,4.79A8.647,8.647,0,0,0,1560,941h1.44a7.247,7.247,0,0,1,7.06-5.667A5.672,5.672,0,0,0,1574.17,929.667Zm-5.67,4.25a4.25,4.25,0,1,1,4.25-4.25A4.257,4.257,0,0,1,1568.5,933.917Z\" transform=\"translate(-1560 -924)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/notification-new-to-pay.svg
// module id = null
// module chunks = 